export default __webpack_public_path__ + "static/media/dominos-bread1.b9e4ec54.png";